/* React hooks */
import {useEffect, useState} from "react";
/* Contexts */
import useDeceased from "../../../hooks/useDeceased";
/* Components */
import DeceasedDetails from "../../../components/common/DeceasedDetails";
import FormChildInfos from "../../../forms/deceased/FormChildInfos";
import Header from "../../../components/common/Header";
import ConfirmChildModal from "../../../components/common/ConfirmChildModal";
import {useParams} from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import {
    getDeceasedAdministrator,
    getDeceasedChildren,
    getDeceasedPartner,
    getDeceasedCorrespondent,
    getDeceasedInfos,
    getAffiliationList,
    createEF, 
    logInEF,
    deleteChildFromDb
} from "../../../api/pro/deceasedReq";
import ViewDeceasedFamilyStatus from "../visualisation pages/ViewDeceasedFamilyStatus";
import ViewConjointMainInfos from "../visualisation pages/ViewConjointMainInfos";
import ViewDeceasedChildInfos from "../visualisation pages/ViewDeceasedChildInfos";
import ViewRegimeInfos from "../visualisation pages/ViewRegimeInfos";
import ViewAdminInfos from "../visualisation pages/ViewAdminInfos";
import ViewCorrespondentInfos from "../visualisation pages/ViewCorrespondentInfos";
import FormSignatory from "../../../forms/deceased/FormSignatory";
import FormConjointInfos from "../../../forms/deceased/FormConjointInfos";
import FormMatrimonialRegime from "../../../forms/deceased/FormMatrimonialRegime";
import {capitalize} from "../../../helper/tools";
import FormCorrespondentChoice from "../../../forms/deceased/FormCorrespondentChoice";
import Missing from "../../Missing";
import {getCountryList} from "../../../api/admin/addressReq";
import useData from "../../../hooks/useData";
import {
    checkRequiredFields,
    displayMessage,
    validateFormInput
} from "../../../helper/tools";
import {safeJwtDecode} from "../../../helper/jwtHelper";
import FormAdminChoice from "../../../forms/deceased/FormAdminChoice";
import Icon from "../../../components/common/Icon";


export default function EditDeceasedComplement() {
    const {
        deceasedInfos, setDeceasedInfos,
        adminInfos, setAdminInfos,
        partnerInfos, setPartnerInfos,
        childrenInfos, setChildrenInfos,
        correspondentInfos, setCorrespondentInfos,
        titleList, setTitleList,
        affiliationList, setAffiliationList
    } = useDeceased();
    const { countryList, setCountryList } = useData();
    const [ newChild, setNewChild ]   = useState(0);
    const {id} = useParams();
    const { auth } = useAuth();
    const token = auth.token;
    const [showModalChild, setShowModalChild] = useState(false);
    const [showConfirmChildModal, setShowConfirmChildModal] = useState(false);
    const [childCreatedCount, setChildCreatedCount] = useState(0);
    const [showSignatoryChoiceModal, setShowSignatoryChoiceModal] = useState(false);
    const [showModalEF, setShowModalEF] = useState(false);
    const [showPartnerModal, setShowPartnerModal] = useState(false);
    const [showRegimeModal, setShowRegimeModal] = useState(false);
    const [showAdminModal, setShowAdminModal] = useState(false);
    const [showCorrespondentModal, setShowCorrespondentModal] = useState(false);
    const [values, setValues] = useState();
    const [message, setMessage] = useState({text: "", type: ""})
    const username = process.env.REACT_APP_OEF_FAMILY_USERNAME;
    const password = process.env.REACT_APP_OEF_FAMILY_PASSWORD;

    const apiAffiliationList = async () => {
        const response = await getAffiliationList(token)
        setAffiliationList(response)
    }

    const apiCountryList = async () => {
        const response = await getCountryList(token)
        setCountryList(response)
    }

    useEffect(() => {
        if (countryList?.length === 0) {
            apiCountryList()
        }
    }, [ token ]);

    const onChangeEfEmail = (e) => {
        setValues({...values, efEmail: e.target.value})
        validateFormInput(e)
    }

    const apiAdminInfos = async () => {
        const response = await getDeceasedAdministrator(token, id)
        if (!response?.error) {
            setAdminInfos(response)
        } else {
            setAdminInfos()
        }
    };

    const apiChildrenInfos = async () => {
        const response = await getDeceasedChildren(token, id)
        setChildrenInfos(response)
    };

    // Résout avec un message d'erreur (affiché par l'appelant dans son propre div.errors, comme
    // les autres erreurs de validation) si la suppression échoue, sinon résout sans valeur.
    const deleteChild = (thisChild) => {
        let body = {
            childId : thisChild,
            deceasedId : id
        }
        if (!window.confirm("Voulez-vous vraiment supprimer cet enfant ?")) {
            return Promise.resolve();
        }
        return deleteChildFromDb(token, body)
            .then((response) => {
                if (response?.error) {
                    return response.error === "The child is the deceased admin."
                        ? "Impossible de supprimer cet enfant : il est désigné comme gestionnaire du défunt. Changez d'abord de gestionnaire avant de le supprimer."
                        : response.error;
                }
                apiChildrenInfos()
                apiAdminInfos()
                setShowModalChild(false)
            })
    };

    const apiPartnerInfos = async () => {
        const response = await getDeceasedPartner(token, id)
        setPartnerInfos(response)
    };

    const apiDeceasedInfos = async () => {
        const response = await getDeceasedInfos(token, id)
        setDeceasedInfos(response)
    };
    const apiCorrespondentInfos = async () => {
        const response = await getDeceasedCorrespondent(token, id)
        setCorrespondentInfos(response)
    };

    useEffect(() => {
        if (!affiliationList?.length > 0) {
            apiAffiliationList()
        }
    }, [ id ]);

    useEffect(() => {
        if (!deceasedInfos?.id == id) {
            apiDeceasedInfos()
            apiPartnerInfos()
            apiAdminInfos()
            apiCorrespondentInfos()
            apiChildrenInfos()
        }
    }, [ deceasedInfos, id ]);

    useEffect(() => {
        if (!childrenInfos || (childrenInfos && childrenInfos?.find(child => child?.deceasedId != id))) {
            apiChildrenInfos()
        }
    }, [ childrenInfos, id ]);

    useEffect(() => {
        if (!adminInfos || (adminInfos && adminInfos?.deceasedId != id)) {
            apiAdminInfos()
        }
    }, [ adminInfos, id ]);

    useEffect(() => {
        if (!deceasedInfos || (deceasedInfos && deceasedInfos?.id != id && !deceasedInfos?.error)) {
            apiDeceasedInfos()
        }
    }, [ partnerInfos, id ]);

    useEffect(() => {
        if (!partnerInfos || (partnerInfos && partnerInfos?.deceasedId != id && !partnerInfos?.error)) {
            apiPartnerInfos()
        }
    }, [ partnerInfos, id ]);

    useEffect(() => {
        if (!correspondentInfos || (correspondentInfos && correspondentInfos?.deceasedId != id && !correspondentInfos?.error)) {
            apiCorrespondentInfos()
        }
    }, [ correspondentInfos, id ]);

    // Scroll to top when modal opens
    useEffect(() => {
        if (showModalChild) {
            const modalElement = document.querySelector('.modal.child-infos');
            if (modalElement) {
                modalElement.scrollTop = 0;
            }
        }
    }, [showModalChild, newChild]);

    const handleChildClick = (e) => {
        const totalExistingChildren = childrenInfos?.length || 0;
        if (totalExistingChildren < 10) {
            setNewChild(totalExistingChildren + 1);
            setShowModalChild(true)
        }
    };

    const handleConfirmYesChild = () => {
        setShowConfirmChildModal(false);
        setNewChild(prev => prev + 1);
        setShowModalChild(true);
    };

    const handleConfirmNoChild = () => {
        setShowConfirmChildModal(false);
        setChildCreatedCount(0);
        setShowAdminModal(true);
    };

    const handleSignatoryForm = (e) => {
        e.preventDefault()
        setShowSignatoryChoiceModal(true)
    }

    const handleCreateEFModal = (e) => {
        e.preventDefault()
        setShowModalEF(true)
    }

    const handleCreateEF = async (e) => {
        e.preventDefault()
        if (!checkRequiredFields()) {
            return;
        }

        try {
            setMessage({text: "", type: ""});

            const loginResponse = await logInEF({username, password});

            const efToken = loginResponse?.token;

            if (!efToken) {
                setMessage({text: "Erreur d'authentification à l'espace famille.", type: "error"});
                return;
            }

            const body = {
                "deceased_id": id,
                "user_email": values?.efEmail
            };

            const response = await createEF(body, efToken);

            if (response?.success) {
                setMessage({text: `${response?.message}`, type: "success"});
                setTimeout(() => {
                    setShowModalEF(false);
                    apiDeceasedInfos();
                }, 2000);
            } else {
                const errorMsg = response?.message || "Une erreur est survenue lors de la création de l'espace famille.";
                setMessage({text: errorMsg, type: "error"});
            }
        } catch (error) {
            console.error("Erreur lors de la création de l'espace famille:", error);
            const errorMsg = error?.response?.data?.message || error?.message || "Erreur lors de la création de l'espace famille.";
            setMessage({text: errorMsg, type: "error"});
        }
    }

    useEffect(() => {
        if (message) {
            displayMessage(message)
        }
    }, [ message ])


    const handleBack = () => {
        setShowModalEF(false)
    }

    return (
        <main>
            { (deceasedInfos?.error || childrenInfos?.error) &&
                <Missing />
            }
            { (!deceasedInfos?.error && !childrenInfos?.error) &&
            <>
            <Header parent="Défunt"
                    location="Informations complémentaires "
                    locationComp ={`${capitalize(deceasedInfos?.lastName)} ${capitalize(deceasedInfos?.firstName)}`}
                    slug={`/defunt/${id}`}
            />
                { showSignatoryChoiceModal &&
                <div className="modal signatory-infos">
                    <FormSignatory apiDeceasedInfos={apiDeceasedInfos} setShowModal={setShowSignatoryChoiceModal}/>
                </div>
            }
            { showModalEF &&
                <div className="modal signatory-infos">
                    <form onSubmit={handleCreateEF} method="post" noValidate>
                        <fieldset>
                            <legend>Création de l'espace famille</legend>
                            <div className="form-input">
                                <label className="required">Création de l'espace famille</label>
                                <span>Un email sera envoyé au correspondant pour lui donner accès à l'espace famille.</span>
                                <input
                                    required
                                    value={values?.efEmail || ""}
                                    type="email"
                                    name="efEmail"
                                    placeholder="Email du correspondant"
                                    onChange={onChangeEfEmail}
                                />

                                {message?.text && (
                                    <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-error'}`}>
                                        {message.text}
                                    </div>
                                )}

                                <button type="submit" className="green-button large">Créer l'espace famille</button>
                                <button type="button" className="blue-button" onClick={handleBack}><i className="fa fa-arrow-left"/><span>Retour</span></button>
                            </div>
                            <div className="errors"></div>
                        </fieldset>
                    </form>
                </div>
            }
            { showPartnerModal &&
                <div className="modal general-infos">
                    <FormConjointInfos
                        setShowModal={setShowPartnerModal}
                        partnerBirthPlaceId={partnerInfos?.birthplaceId}
                        partnerAddressId={partnerInfos?.addressId}
                        partnerId={partnerInfos?.id}
                        legend="Informations du conjoint"
                        apiAdminInfos={apiAdminInfos}
                        apiDeceasedInfos={apiDeceasedInfos}
                        apiPartnerInfos={apiPartnerInfos}
                        apiCorrespondentInfos={apiCorrespondentInfos}
                        data={partnerInfos}
                        setShowRegimeModal={setShowRegimeModal}
                        deceasedInfos={deceasedInfos}
                        setShowChildModal={setShowModalChild}
                        setNewChild={setNewChild}
                        setShowConfirmChildModal={setShowConfirmChildModal}
                        setChildCreatedCount={setChildCreatedCount}
                    />
                </div>
            }
            {/*{ showRegimeModal &&
                <div className="modal regime-infos">
                    <FormMatrimonialRegime
                        setShowModal={setShowRegimeModal}
                        apiPartnerInfos={apiPartnerInfos}
                        partnerInfos={partnerInfos}
                        legend="Informations du régime matrimonial"
                        setShowChildModal={setShowModalChild}
                        setNewChild={setNewChild}
                        setShowConfirmChildModal={setShowConfirmChildModal}
                        setChildCreatedCount={setChildCreatedCount}
                    />
                </div>
            }*/}
            { showAdminModal &&
                <div className="modal admin-choice">
                    <FormAdminChoice
                        adminInfos={adminInfos}
                        setShowModal={setShowAdminModal}
                        deceasedInfos={deceasedInfos}
                        childrenInfos={childrenInfos}
                        apiAdminInfos={apiAdminInfos}
                        apiChildrenInfos={apiChildrenInfos}
                        apiDeceasedInfos={apiDeceasedInfos}
                        data={adminInfos}
                        legend="Identité du gestionnaire"
                        setShowCorrespondentModal={setShowCorrespondentModal}
                    />
                </div>
            }
            { showCorrespondentModal &&
                <div className="modal correspondent-infos">
                    <FormCorrespondentChoice
                        deceasedInfos={deceasedInfos}
                        apiDeceasedInfos={apiDeceasedInfos}
                        apiCorrespondentInfos={apiCorrespondentInfos}
                        legend="Identité du correspondant"
                    />
                </div>
            }
            { showModalChild &&
                <div className="modal child-infos">
                    {(() => {
                        const totalExistingChildren = childrenInfos?.length || 0;

                        if (newChild > 0 && newChild <= totalExistingChildren) {
                            const childToShow = childrenInfos[newChild - 1];
                            return (
                                <FormChildInfos
                                    apiAdminInfos={apiAdminInfos}
                                    apiChildrenInfos={apiChildrenInfos}
                                    apiPartnerInfos={apiPartnerInfos}
                                    deleteChild={deleteChild}
                                    setNewChild={setNewChild}
                                    setShowModal={setShowModalChild}
                                    childId={"" + (newChild - 1)}
                                    child={childToShow}
                                    key={"child" + childToShow?.id}
                                    legend={`Enfant ${newChild}`}
                                    childrenInfos={childrenInfos}
                                    currentChildIndex={newChild - 1}
                                    setShowAdminModal={setShowAdminModal}
                                    setShowConfirmChildModal={setShowConfirmChildModal}
                                    setChildCreatedCount={setChildCreatedCount}
                                />
                            );
                        }
                        else if (newChild > totalExistingChildren && newChild <= 10) {
                            const newChildNumber = newChild - totalExistingChildren;
                            return (
                                <FormChildInfos
                                    apiAdminInfos={apiAdminInfos}
                                    apiChildrenInfos={apiChildrenInfos}
                                    apiPartnerInfos={apiPartnerInfos}
                                    deleteChild={deleteChild}
                                    setNewChild={setNewChild}
                                    setShowModal={setShowModalChild}
                                    childId={"new" + newChildNumber}
                                    key={"newChild" + newChildNumber}
                                    legend={`Enfant ${newChild} : `}
                                    setShowAdminModal={setShowAdminModal}
                                    setShowConfirmChildModal={setShowConfirmChildModal}
                                    setChildCreatedCount={setChildCreatedCount}
                                />
                            );
                        }
                    })()}
                </div>
            }
            <div className="flex">
                <div key={"form1"}>
                    <div>
                        <ViewDeceasedFamilyStatus
                            apiDeceasedInfos={apiDeceasedInfos}
                            legend="Statut marital"
                            deceasedInfos={deceasedInfos}
                            setShowPartnerModal={setShowPartnerModal}
                            setShowChildModal={setShowModalChild}
                            setNewChild={setNewChild}
                            setShowConfirmChildModal={setShowConfirmChildModal}
                            setChildCreatedCount={setChildCreatedCount}
                        />
                        {(deceasedInfos?.maritalStatus != "2" && deceasedInfos?.maritalStatus != "3" && deceasedInfos?.maritalStatus != "4") &&
                            <ViewConjointMainInfos apiDeceasedInfos={apiDeceasedInfos} apiAdminInfos={apiAdminInfos} apiCorrespondentInfos={apiCorrespondentInfos} apiPartnerInfos={apiPartnerInfos} partnerInfos={partnerInfos} legend="Informations du conjoint"/>
                        }
                        {(deceasedInfos?.maritalStatus == "1" || deceasedInfos?.maritalStatus == "5" || deceasedInfos?.maritalStatus == "7") &&
                            <ViewRegimeInfos partnerInfos={partnerInfos} apiPartnerInfos={apiPartnerInfos} legend="Séparation des biens"/>
                        }
                        {childrenInfos &&
                            childrenInfos?.map((child, index) => (
                                <ViewDeceasedChildInfos
                                    apiAdminInfos={apiAdminInfos}
                                    apiChildrenInfos={apiChildrenInfos}
                                    deleteChild={deleteChild}
                                    childId={"" + index}
                                    child={child}
                                    legend={"Enfant " + (index + 1)}
                                    key={"child" + child?.id}
                                />
                            ))
                        }
                        <button type="button" className="blue-button" onClick={handleChildClick}>Ajouter un enfant</button>
                        <ViewAdminInfos
                            apiPartnerInfos={apiPartnerInfos}
                            apiAdminInfos={apiAdminInfos}
                            apiChildrenInfos={apiChildrenInfos}
                            apiDeceasedInfos={apiDeceasedInfos}
                            apiCorrespondentInfos={apiCorrespondentInfos}
                            childrenInfos={childrenInfos}
                            deceasedInfos={deceasedInfos}
                            adminInfos={adminInfos}
                            legend="Informations du gestionnaire"
                            data={adminInfos}
                        />
                        <ViewCorrespondentInfos
                            deceasedInfos={deceasedInfos}
                            apiPartnerInfos={apiPartnerInfos}
                            apiAdminInfos={apiAdminInfos}
                            apiChildrenInfos={apiChildrenInfos}
                            apiDecesedInfos={apiDeceasedInfos}
                            apiCorrespondentInfos={apiCorrespondentInfos}
                            deceased={deceasedInfos}
                            correspondent={correspondentInfos}
                            adminInfos={adminInfos}
                            legend="Informations du correspondant"
                        />
                        <fieldset>
                            <legend>Informations sur le signataire<i className="fa fa-pen-to-square" onClick={handleSignatoryForm}/></legend>
                            <div className="form-input">
                                <label>Le signataire des courriers est</label>
                                <span>{deceasedInfos?.gestionnaireSignatory == 1 ? "Le gestionnaire" : deceasedInfos?.gestionnaireSignatory == 0 ? "Le correspondant" : ""}</span>
                            </div>
                        </fieldset>
                        <fieldset>
                        {
                            (adminInfos?.address || correspondentInfos?.address ) &&
                            <>
                                <legend>Espace famille</legend>
                                <div className="form-input">
                                    <button className="green-button" onClick={handleCreateEFModal}>Créer l'accès à l'espace famille</button>
                                </div>
                            </>
                        }
                        {/*<button className="blue-button">Créer la cagnotte des proches</button>*/}
                        </fieldset>
                    </div>
                </div>
                <DeceasedDetails data={deceasedInfos}/>
            </div>
            <ConfirmChildModal
                showModal={showConfirmChildModal}
                onYes={handleConfirmYesChild}
                onNo={handleConfirmNoChild}
                childCount={childCreatedCount}
            />
            </>
            }
        </main>
    )
}

